import { format, isValid } from 'date-fns';
import { formatDate } from './date';

/**
 * Вырезаем таймзону, чтобы показать местное время
 * @param {string} date 2018-12-26T10:00:00.000+03:00
 * @returns {string} 2018-12-26T10:00:00
 */
export const getDateWithoutTimezone = (date: string) => {
  const [dateWithoutTimezone] = date.split('.');
  const parseDate = new Date(dateWithoutTimezone);

  const isValidDate = isValid(parseDate);
  return isValidDate ? dateWithoutTimezone : date;
};

/**
 * Возвращает время из даты безопасно, с фолбеком на текст
 * @param {string} date
 * @param {string} invalidText
 * @returns {string} HH:mm | Неизвестно
 */
export const getHoursSafeWithoutTimezone = (
  date: string,
  invalidText = 'Неизвестно'
) => {
  const dateString = getDateWithoutTimezone(date);

  if (!dateString) return invalidText;

  const parseDate = new Date(dateString);
  return format(parseDate, 'HH:mm');
};

/**
 * Форматирует дату, например 23 сен, пт
 * @param {string} date
 * @returns {string}
 */
export const formatDateToDayMonth = (date: string) =>
  formatDate(date, 'dd MMM');

/**
 * Возвращает день недели
 * @param {string} date
 * @returns {string} пятница
 */
export const getDateName = date => formatDate(date, 'eeee');
